import script from "./DisplaySettings.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplaySettings.vue?vue&type=script&setup=true&lang=js"

import "./DisplaySettings.vue?vue&type=style&index=0&id=ff92407c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff92407c"]])

export default __exports__